import type { DatasetsMutatorCreateDatasetsProps } from "./datasets-mutator-create-datasets.type";

import { useDatasetsMutatorCreateDatasets } from "./datasets-mutator-create-datasets.hook";

const DatasetsMutatorCreateDatasets = (
  props: DatasetsMutatorCreateDatasetsProps
) => {
  useDatasetsMutatorCreateDatasets(props);

  return null;
};

export default DatasetsMutatorCreateDatasets;
